import { render, staticRenderFns } from "./ContMyReports.vue?vue&type=template&id=06ef5d28&scoped=true&lang=pug"
import script from "./ContMyReports.vue?vue&type=script&lang=js"
export * from "./ContMyReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ef5d28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ef5d28')) {
      api.createRecord('06ef5d28', component.options)
    } else {
      api.reload('06ef5d28', component.options)
    }
    module.hot.accept("./ContMyReports.vue?vue&type=template&id=06ef5d28&scoped=true&lang=pug", function () {
      api.rerender('06ef5d28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/refactoring/ContMyReports.vue"
export default component.exports